import React, { useState } from 'react';
import { getAccountSetupInstructions } from '../../utils/accountSetupDisplay';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  IconButton,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  Close as CloseIcon,
  ContentCopy as CopyIcon,
} from '@mui/icons-material';

const copyToClipboard = async (value) => {
  if (!value) return;
  try {
    await navigator.clipboard.writeText(value);
  } catch (_) {
    // ignore
  }
};

const CopyField = ({ label, value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await copyToClipboard(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <TextField
      fullWidth
      label={label}
      value={value || ''}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleCopy} edge="end" aria-label={`Copy ${label}`}>
              <CopyIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      helperText={copied ? 'Copied' : ' '}
      sx={{ mb: 2 }}
    />
  );
};

const AccountCreatedDialog = ({
  open,
  onClose,
  title = 'Account Created',
  accountSetup,
  subtitle,
}) => {
  if (!accountSetup) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {title}
        <IconButton onClick={onClose} size="small" aria-label="Close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {subtitle}
          </Typography>
        )}

        {accountSetup.emailError && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Email delivery failed: {accountSetup.emailError}
          </Alert>
        )}

        <Alert severity="warning" sx={{ mb: 3 }}>
          {getAccountSetupInstructions(accountSetup)}
        </Alert>

        <Alert severity="info" sx={{ mb: 2 }}>
          Email OTP is required on every sign-in for this account.
        </Alert>

        {accountSetup.emailError && (
          <>
            <CopyField label="Username" value={accountSetup.username} />
            <CopyField label="Temporary Password" value={accountSetup.temporaryPassword} />
            <CopyField label="Login URL" value={accountSetup.loginUrl} />
            <CopyField label="Password Setup Link" value={accountSetup.passwordSetupUrl} />
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountCreatedDialog;
